module.exports = __webpack_public_path__ + "prod/1.42.2/img/platform-img.63080afe.png";